import { render, staticRenderFns } from "./inbound-fax-missed-icon.vue?vue&type=template&id=5361bd4e"
import script from "./inbound-fax-missed-icon.vue?vue&type=script&lang=js"
export * from "./inbound-fax-missed-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5361bd4e')) {
      api.createRecord('5361bd4e', component.options)
    } else {
      api.reload('5361bd4e', component.options)
    }
    module.hot.accept("./inbound-fax-missed-icon.vue?vue&type=template&id=5361bd4e", function () {
      api.rerender('5361bd4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/contact-activity/inbound-fax-missed-icon.vue"
export default component.exports